import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StoreService } from '../core/store.service';
import { Observable } from 'rxjs';
import * as fileSaver from 'file-saver';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Injectable()
export class DownloadService {

  constructor(
    protected http: HttpClient,
    protected store: StoreService
  ) { }

  downloadFile(idDoc: string): void {
    this.store.showSplash(true);
    const fileName: string = (idDoc.indexOf('.') === -1 && !isNaN(parseInt(idDoc))) ? `${idDoc}.pdf` : idDoc;

    this.download(idDoc).subscribe((response: ArrayBufferView): void => {
      let fileType: string = '';
      switch (fileName.split('.').pop()) {
        case 'pdf': fileType = 'application/pdf'; break;
        case 'jpg': fileType = 'image/jpg'; break;
        case 'jpeg': fileType = 'image/jpeg'; break;
        case 'png': fileType = 'image/png'; break;
        case 'gif': fileType = 'image/gif'; break;
        case 'xml': fileType = 'application/xml'; break;
        case 'txt': fileType = 'text/plain'; break;
        case 'doc': fileType = 'application/vnd.ms-word'; break;
        case 'docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
        case 'xls': fileType = 'application/vnd.ms-excel'; break;
        case 'xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
        case 'bmp': fileType = 'image/bmp'; break;
        case 'wav': fileType = 'audio/wav'; break;
        case 'ppt': fileType = 'application/vnd.ms-powerpoint'; break;
        case 'pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
        case 'dwg': fileType = 'image/vnd.dwg'; break;
      }

      const blob: Blob = new Blob([(response)], {
        type: fileType,
      });

      if (blob.size > 0) {
        if (window.navigator && fileType !== 'application/pdf') {
          // window.navigator.msSaveOrOpenBlob(blob, fileName);
          fileSaver.saveAs(blob, fileName);
        } else {
          // Pour le PDF on l'ouvre dans une nouvelle fenêtre
          const objectUrl: string = URL.createObjectURL(blob);
          window.open(objectUrl);
        }
      }
      this.store.showSplash(false);

    }, (error: any): void => {
      if (this.store.isBrowserMS()) {
        // in case of microsoft browser the TextDecoder object necessary to convert array buffer to string is unavailable
        this.store.warning(`Un problème est survenu lors du téléchargement du fichier ${fileName} (vérifier si il existe réellement)`);
      }
      else {
        const e1: string | null = localStorage.getItem('ERROR');
        if (e1) {
          const e2: any = JSON.parse(e1);
          try {
            if (error.url.indexOf('api/download') > -1) {
              const er: string = new TextDecoder('utf-8').decode(new Uint8Array(error.error));
              this.store.warning(er);
            }
          }
          catch (tryerr) {
            console.error('%c error management problem:', 'color: #FF0000; font-size: 1rem; font-family: Arial;');
            console.error(`%c ${tryerr.message}`, 'color: #FF0000; font-size: 1rem; font-family: Arial;');
          }
        }
      }
      this.store.showSplash(false);
    });
  }

  private download(fileName: string): Observable<object> {
    const data: any = { QueovalOriginalName: fileName };
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };
    return this.http.post(`${EndWithSlash(this.store.AppParams.apiUrl)}api/download`, data, config);
  }
}
